import { Component } from "@angular/core";
import { ActionSheetController, IonicPage, LoadingController, Modal, ModalController, ToastController } from "ionic-angular";
import { iConfiguracion } from "../../models/basePage";
import { PaginaBasica } from "../../models/PaginaBase";
import { APIOnLine } from "../../services/api/api.services";
import { Proxy } from "../../services/proxy/proxy.service";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { OtrosAuxiliaresService } from '../../services/api/otrosauxiliares.service';
import { Observable } from "rxjs";

import * as mod from '../../models/otrosAuxiliares';
import { NuevaPersonaPage } from "../nueva-persona/nueva-persona";

@IonicPage()
@Component({
  selector: "otros-auxiliares",
  templateUrl: "otros-auxiliares.html",
})
export class OtrosAuxiliaresPage extends PaginaBasica {

  // #region Propiedades del controlador
  public configuraciones: iConfiguracion;
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;

  public auxiliares: Proxy.ListaPrPersonaAlineable;
  public listaParticipantes$: Observable<mod.ActasParticipacionOtrosAuxiliares[]>;
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController,
    public OtrosAuxiliaresService: OtrosAuxiliaresService
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidEnter() {
    console.log("--- ENTRO EN LA PÁGINA: OTROS AUXILIARES ---");
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    // Definición de observables
    this.listaParticipantes$ = this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares$;

    this.participantes = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.idEquipo
    );
    this.licencias = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );
    this.auxiliares = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );

    this.ProcesarLicenciasAuxiliares();
  }

  // #region Métodos del controlador

  /**
   * Color para indicar si está alineado o no.
   * @param dni DNI de la persona (identificador)
   * @returns Nombre del color
   */
  ColorAlineado(dni: string): string {
    return this.EstaAlineado(dni) ? 'peter-river' : 'emerald';
  }

  EliminarAlineacion(): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Borrar auxiliares",
      subTitle:
        "¿Desea eliminar los auxiliares alineados?",
      buttons: [
        {
          text: "Eliminar",
          handler: () => {
            this.OtrosAuxiliaresService.EliminarTodos(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo);
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  public EliminarParticipante(licencia: Proxy.PrPersonaAlineable): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Eliminar participante",
      subTitle:
        "¿Desea eliminar de la lista de auxiliares a " +
        licencia.nombre +
        " " +
        licencia.apellido1 +
        " " +
        licencia.apellido2 +
        "?",
      buttons: [
        {
          text: "Eliminar",
          handler: () => {
            console.log("Datos de la licencia a eliminar: ");
            console.log(licencia);

            this.participantes.EliminarParticipante(licencia);
            this.licencias.EliminarAlineado(licencia);
            this.ProcesarLicenciasAuxiliares();
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  /**
   * Comprueba si la la persona está alineada
   * @param dni DNI de la persona
   * @returns Indica si se está alineado
   */
  EstaAlineado(dni: string): boolean {
    if (this.OtrosAuxiliaresService != null &&
      this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares != null &&
      this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares.length > 0) {
      return this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares.find(m => m.identificador.toUpperCase().trim() == dni.toUpperCase().trim()) != null
        ? true
        : false;
    } else {
      return false;
    }
  }

  /**
   * Incluye una licencia como participante (alinear).
   * @param licencia Datos de la licencia a incluir como auxiliar participante.
   */
  IncluirAuxiliar(licencia: Proxy.PrPersonaAlineable): void {
    if (this.OtrosAuxiliaresService.ObtenerPorIdentificador(licencia.identificador) == null) {

      let datos: mod.ActasParticipacionOtrosAuxiliares = {
        apellido1: licencia.apellido1,
        apellido2: licencia.apellido2,
        id: 0,
        idCalendario: this.designacion.idCalendario,
        idDesignacion: this.designacion.idDesignacion,
        identificador: licencia.identificador,
        idEquipo: this.idEquipo,
        nombre: licencia.nombre,
        tipoLicencia: licencia.tipoLicencia
      };

      this.OtrosAuxiliaresService.Guardar(this.designacion.urlApi, datos);
    } else {
      this.OtrosAuxiliaresService.Eliminar(this.designacion.urlApi, this.OtrosAuxiliaresService.ObtenerPorIdentificador(licencia.identificador).id);
    }
  }

  /**
   * Abre la ventana modal para incluir a una nueva persona como auxiliar.
   */
  NuevaPersona(): void {
    let modal: Modal = this.modalCtrl.create(NuevaPersonaPage, {
      esAuxiliar: false,
      esEntrenador: false,
      esOtroAuxiliar: true,
      delegadoEquipo: false,
      delegadoCampo: false
    });
    modal.onDidDismiss(() => {
      this.participantes
        .CargarListaParticipacion()
        .then((resultado: boolean) => {
          this.ProcesarLicenciasAuxiliares();
        })
        .catch((error) => console.error(error));
    });
    modal.present();
  }

  /**
   * Obtiene la lista de licencias y procesa estas para incluir las necesarias en la lista de otros auxiliares.
   */
  private ProcesarLicenciasAuxiliares(): void {
    this.auxiliares.lista = [];

    this.MostrarOcultarCarga(false, "cargando auxiliares");

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
        return this.participantes.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(false, true, true, true);
      })
      .then((resultado: boolean) => {

        // Recorrer la lista de licencias obtenidas, para filtrarla y guardar solo los auxiliares en la varible 'auxiliares'
        if (this.licencias != null && this.licencias.lista != null) {
          this.licencias.lista.forEach((valor: Proxy.PrPersonaAlineable) => {
            let nombreTipo: string = valor.tipoLicencia.toUpperCase();
            if (nombreTipo.indexOf("MONITOR") < 0 &&
              (
                nombreTipo.indexOf("ENTRENADOR") < 0 ||
                (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("AUXILIAR") >= 0) ||
                (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("SEGUNDO") >= 0) ||
                (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("PRACTICAS") >= 0)
              ) &&
              (nombreTipo.indexOf("DELEGADO") < 0)) {

              // Revisar las personas sin licencia, para definir correctamente el tipo de su licencia (viene en el campo codigoLicencia).
              if (valor.sinLicencia && valor.codigoBarras.trim().length > 0) {
                valor.tipoLicencia = valor.codigoBarras;
              }

              this.auxiliares.lista.push(valor);
            }
          });
        }

        // Carga de los participantes establecidos
        this.OtrosAuxiliaresService.Lista(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo).subscribe();

        this.MostrarOcultarCarga(true);
      })
      .catch((error) => console.error(error));
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/otros-auxiliares/otros-auxiliares.ts